// src/config/constants.js
// Constantes globales de la aplicación

// ID del profesor actual (legacy)
// Nota: la app usa Firebase Auth uid como fuente de verdad.
export const PROFESOR_ID = 'profesor-demo-001';

// Configuración de Firebase
// Fuente única: variables de entorno (Vite: VITE_*)
const env = import.meta.env || {};
const getEnv = (viteKey, legacyKey) => env[viteKey] || env[legacyKey] || '';

export const FIREBASE_CONFIG = {
  apiKey: getEnv('VITE_FIREBASE_API_KEY', 'REACT_APP_FIREBASE_API_KEY'),
  authDomain: getEnv('VITE_FIREBASE_AUTH_DOMAIN', 'REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: getEnv('VITE_FIREBASE_PROJECT_ID', 'REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getEnv('VITE_FIREBASE_STORAGE_BUCKET', 'REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getEnv('VITE_FIREBASE_MESSAGING_SENDER_ID', 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getEnv('VITE_FIREBASE_APP_ID', 'REACT_APP_FIREBASE_APP_ID'),
  measurementId: getEnv('VITE_FIREBASE_MEASUREMENT_ID', 'REACT_APP_FIREBASE_MEASUREMENT_ID')
};

// Legacy: evitar en código nuevo; usar `useAuth().user.uid` o `getAuth().currentUser.uid`.
export const getProfesorId = () => PROFESOR_ID;

// Legacy no-op
export const setProfesorId = (_id) => {};
